var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectionalArrows(_ref, svgRef) {
  var _ref2, _ref3;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5026 11.6666L3.33594 7.49992L7.5026 3.33325",
    stroke: "#1A4338",
    style: (_ref2 = {
      stroke: "#1A4338"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6693 16.6667V10.8333C16.6693 9.94928 16.3181 9.10143 15.693 8.47631C15.0678 7.85119 14.22 7.5 13.3359 7.5H3.33594",
    stroke: "#1A4338",
    style: (_ref3 = {
      stroke: "#1A4338"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionalArrows);
export default __webpack_public_path__ + "static/media/DirectionalArrows.a01ad6e8.svg";
export { ForwardRef as ReactComponent };